import { render } from "./pages-banners-list.vue?vue&type=template&id=6df1924b"
import script from "./pages-banners-list.vue?vue&type=script&lang=js"
export * from "./pages-banners-list.vue?vue&type=script&lang=js"

import "./pages-banners-list.vue?vue&type=style&index=0&id=6df1924b&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__